import {Dialogs} from '@mintdata-wsp/wsp/controllers/common/DialogsController';
import {controllers} from '@mintdata-wsp/wsp/controllers/WspControllers';
import {BuildVersion} from '@mintdata-wsp/wsp/ui/components/general/BuildVersion';
import {BasePage} from '@mintdata-wsp/wsp/ui/pages/BasePage';
import {LogoHeader} from '@mintdata-wsp/wsp/ui/pages/general/LogoHeader';
import * as classnames from 'classnames/bind';
import {observer} from 'mobx-react';
import * as React from 'react';

const styles = require('./JoinPage.less');
const cx = classnames.bind(styles);

@observer
export class JoinOrganizationPage extends BasePage<any, any>
{
    componentDidMount()
    {
        controllers.ui.join.setJoinOrganization();
        controllers.ui.dialogs.showDialog(Dialogs.JoinForm, true, this.props);
        controllers.ui.anyPage.disablePageLoader();
    }

    render()
    {
        return  <div className={cx('joinPage')}>
            <LogoHeader/>
            <BuildVersion/>

            {controllers.ui.dialogs.renderAllPublic()}
        </div>;
    }
}
